import React from 'react';

import { useMutateKaiAssistants } from '@hooks/kaiAssistants/useMutateKaiAssistants';

import { IKaiAssistantDTO } from '@interfaces/kai/dto/kaiDTO';

import KaiAssistantForm from '../KaiAssistantForm';
import { ISubmitHandlerProps } from '../KaiAssistantForm/KaiAssistantForm';

export interface IEditKaiAssistantProps {
	assistant: IKaiAssistantDTO;
	organizationId: string;
	close: () => void;
}

function EditKaiAssistant({
	assistant,
	organizationId,
	close,
}: IEditKaiAssistantProps) {
	const {
		updateKaiAssistant,
		isUpdatingKaiAssistant,
	} = useMutateKaiAssistants();

	const handleEditKaiAssistant = async (data: ISubmitHandlerProps) => {
		await updateKaiAssistant({
			name: data.name!,
			kaiId: data.kaiId!,
			organizationId,
			id: data.id!,
			userIds: data.userIds,
		});
	};

	return (
		<KaiAssistantForm
			close={close}
			id={assistant.id}
			isLoading={isUpdatingKaiAssistant}
			kaiId={assistant.kaiId}
			name={assistant.name}
			organizationId={organizationId}
			submitHandler={handleEditKaiAssistant}
			users={assistant.users}
		/>
	);
}

export default EditKaiAssistant;
